module.exports = __webpack_public_path__ + "fonts/iconfont.b8513ba.woff";